import { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { Participants, Session, Login, ForgotPassword } from '../pages';
import PrivateRoute from './privateRouter';
import { GuestParticipants } from '../pages/index';
import UpdatePassword from '../pages/updatePassword';
import TeamPerformance from '../pages/teamPerformance';
import Connection from '../pages/connection';

const MainRouter = ({ socket }) => {
	const isLoggedIn = localStorage.getItem('token') ? true : false;
	const navigate = useNavigate();
	const [resetToken, setResetToken] = useState('');
	const [forgotErrorDescription, setForgotErrorDescription] = useState('');

	useEffect(() => {
		try {
			const urlParams = new URLSearchParams(window.location.hash.substring(1));
			const accessToken = urlParams.get('access_token');
			const urlError = urlParams.get('error_description');
			if (urlError) {
				setForgotErrorDescription(urlError);
			} else {
				const expiryTimestamp = urlParams.get('expires_at');
				const isTokenExpired = () =>
					expiryTimestamp &&
					Math.floor(Date.now() / 1000) >= parseInt(expiryTimestamp, 10);

				if (accessToken && expiryTimestamp) {
					if (isTokenExpired()) {
						navigate('/login');
					} else {
						setResetToken(accessToken);
					}
				}
			}
		} catch (error) {
			console.error('Failed to parse URL params:', error);
		}
	}, [navigate]);

	const AuthRedirect = () => {
		return isLoggedIn ? <Navigate to="/session" /> : <Login />;
	};


	// 	 useEffect(() => {
	//     const isOpera =
	//       (typeof window !== 'undefined' &&
	//         ((!!window.opr && !!window.opr.addons) ||
	//          !!window.opera ||
	//          navigator.userAgent.includes('OPR/')));

	//     if (isOpera) {
	//       document.body.classList.add('is-opera');
	//     }
	//   }, []);

	useEffect(() => {
		if (typeof window !== 'undefined') {
			const userAgent = navigator.userAgent;

			const isOpera =
				(!!window.opr && !!window.opr.addons) ||
				!!window.opera ||
				userAgent.includes('OPR/');

			const isFirefox = userAgent.toLowerCase().includes('firefox');

			if (isOpera) {
				document.body.classList.add('is-opera');
			}

			if (isFirefox) {
				document.body.classList.add('is-firefox');
			}
		}
	}, []);


	return (
		<Routes>
			<Route
				path='/reset-password'
				element={<ForgotPassword />}
			/>
			<Route
				path='/teams-performance/:id'
				element={<TeamPerformance isLoggedIn={isLoggedIn} socket={socket} />}
			/>
			<Route
				path='/update-password'
				element={
					<UpdatePassword
						forgotErrorDescription={forgotErrorDescription}
						accessToken={resetToken}
					/>
				}
			/>
			<Route path="/" element={<AuthRedirect />} />
			<Route path="/login" element={<AuthRedirect />} />
			<Route
				path='/session'
				element={
					<PrivateRoute>
						<Session socket={socket} />
					</PrivateRoute>
				}
			/>
			<Route
				path='/connection'
				element={<Connection socket={socket} />}
			/>
		<Route
			path='/:dynamicPart/:id'
			element={
				isLoggedIn ? (
					<PrivateRoute>
						<Participants socket={socket} />
					</PrivateRoute>
				) : (
					<GuestParticipants socket={socket} isLoggedIn={isLoggedIn} />
				)
			}
		/>
			{/* <Route
				path='*'
				element={<Navigate to={isLoggedIn ? 'session' : ''} />}
			/> */}
		</Routes>
	);
};

export default MainRouter;
